import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  class: "birthday-overlay",
  role: "dialog",
  "aria-modal": "true"
}
const _hoisted_2 = { class: "starlit-sky" }
const _hoisted_3 = { class: "floating-confetti" }
const _hoisted_4 = { class: "floating-balloons" }
const _hoisted_5 = { class: "content-card" }
const _hoisted_6 = { class: "truck-parade" }
const _hoisted_7 = { class: "truck-highway" }
const _hoisted_8 = { class: "gratitude-notes" }
const _hoisted_9 = { class: "note-row" }
const _hoisted_10 = {
  key: 0,
  class: "firework-field",
  "aria-hidden": "true"
}

import { computed, ref } from 'vue';

const milestoneAge = 16;

export default /*@__PURE__*/_defineComponent({
  __name: 'KatelynBirthdaySurprise',
  emits: ["close"],
  setup(__props, { emit: __emit }) {

const emit = __emit;

const confettiSeed = ref(0);
const balloonSeed = ref(0);
const starSeed = ref(0);
const truckLightSeed = ref(0);
const showFireworks = ref(false);
const fireworkBursts = ref<Array<{ id: number; left: number; top: number; delay: number; hue: number }>>([]);

const pseudoRandom = (seed: number, offset: number) => {
  const x = Math.sin(seed * 999 + offset * 13.37) * 43758.5453;
  return x - Math.floor(x);
};

const accentPalette = ['#ff4d6d', '#ff9f1c', '#ffd23f', '#59d9a3', '#845ef7', '#f77fbe', '#70d6ff'];

const confettiPieces = computed(() => {
  const seed = confettiSeed.value + 1;
  return Array.from({ length: 160 }, (_, index) => {
    const hueShift = pseudoRandom(seed, index) * 360;
    const secondaryHue = (hueShift + 60 + pseudoRandom(seed, index + 40) * 120) % 360;
    return {
      id: index,
      left: pseudoRandom(seed, index + 10) * 100,
      delay: pseudoRandom(seed, index + 20) * 4,
      duration: 6 + pseudoRandom(seed, index + 30) * 6,
      rotation: pseudoRandom(seed, index + 50) * 360,
      gradient: `linear-gradient(135deg, hsla(${hueShift}, 90%, 65%, 0.95), hsla(${secondaryHue}, 90%, 70%, 0.9))`
    };
  });
});

const balloons = computed(() => {
  const seed = balloonSeed.value + 7;
  const balloonEmojis = ['🎈', '🎉', '💖', '🌟', '🎂', '🪩'];
  return Array.from({ length: 12 }, (_, index) => {
    const emoji = balloonEmojis[Math.floor(pseudoRandom(seed, index) * balloonEmojis.length)];
    const hue = pseudoRandom(seed, index + 15) * 360;
    const saturation = 70 + pseudoRandom(seed, index + 25) * 20;
    const lightness = 65 + pseudoRandom(seed, index + 35) * 20;
    const highlight = (lightness + 20) % 100;
    return {
      id: index,
      left: 5 + pseudoRandom(seed, index + 5) * 90,
      delay: pseudoRandom(seed, index + 60) * 3,
      duration: 12 + pseudoRandom(seed, index + 70) * 8,
      background: `radial-gradient(circle at 30% 30%, hsla(${hue}, ${saturation}%, ${highlight}%, 0.95) 0%, hsla(${hue}, ${saturation}%, ${lightness}%, 0.9) 60%, hsla(${hue}, ${saturation}%, ${lightness - 10}%, 0.8) 100%)`,
      shadow: `0 0 20px hsla(${hue}, ${saturation}%, ${lightness + 5}%, 0.6)`,
      emoji
    };
  });
});

const starfield = computed(() => {
  const seed = starSeed.value + 3;
  return Array.from({ length: 80 }, (_, index) => ({
    id: index,
    left: pseudoRandom(seed, index) * 100,
    top: pseudoRandom(seed, index + 40) * 100,
    delay: pseudoRandom(seed, index + 60) * 5,
    duration: 5 + pseudoRandom(seed, index + 80) * 6,
    opacity: 0.4 + pseudoRandom(seed, index + 100) * 0.5
  }));
});

const truckLights = computed(() => {
  const seed = 42 + truckLightSeed.value;
  return Array.from({ length: 10 }, (_, index) => {
    const hue = (pseudoRandom(seed, index + 10) * 360 + 200) % 360;
    return {
      id: index,
      left: pseudoRandom(seed, index) * 100,
      delay: pseudoRandom(seed, index + 20) * 4,
      color: `radial-gradient(circle, hsla(${hue}, 85%, 65%, 0.9) 0%, rgba(0,0,0,0) 70%)`
    };
  });
});

const appreciationNotes = [
  {
    text: '“the sweetest birthday girl” - isabel.marryyy',
    accent: accentPalette[0]
  },
  {
    text: '“happy 16th pretty girl!!” - isabella_mw_',
    accent: accentPalette[5]
  },
  {
    text: '“Love this and you🩷🩷.” - its.anya27',
    accent: accentPalette[1]
  },
  {
    text: '“so pretty angel!!!.” - eabruner (aka not the favorite cousin)',
    accent: accentPalette[2]
  },
  {
    text: '“so cuteee” - samantha.kennedy1',
    accent: accentPalette[3]
  },
  {
    text: '“happy 16th gorgeous!!” - blakely_gracegomez',
    accent: accentPalette[4]
  },
  {
    text: '"“happiest 16th!"” - lauren.patterson27',
    accent: accentPalette[5]
  },
  {
    text: '“aw this is adorable” - also lauren.patterson27',
    accent: accentPalette[2]
  }
];

const birthdayChapter = milestoneAge;

const closeSurprise = () => {
  showFireworks.value = false;
  emit('close');
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[8] || (_cache[8] = _createElementVNode("div", { class: "background-glow" }, null, -1)),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(starfield.value, (star) => {
        return (_openBlock(), _createElementBlock("span", {
          key: `star-${star.id}`,
          class: "sky-star",
          style: _normalizeStyle({
          left: `${star.left}%`,
          top: `${star.top}%`,
          animationDelay: `${star.delay}s`,
          animationDuration: `${star.duration}s`,
          opacity: star.opacity
        })
        }, null, 4))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(confettiPieces.value, (piece) => {
        return (_openBlock(), _createElementBlock("div", {
          key: `confetti-${piece.id}`,
          class: "confetti-piece",
          style: _normalizeStyle({
          left: `${piece.left}%`,
          animationDelay: `${piece.delay}s`,
          animationDuration: `${piece.duration}s`,
          transform: `rotate(${piece.rotation}deg)`,
          background: piece.gradient
        })
        }, null, 4))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(balloons.value, (balloon) => {
        return (_openBlock(), _createElementBlock("div", {
          key: `balloon-${balloon.id}`,
          class: "balloon",
          style: _normalizeStyle({
          left: `${balloon.left}%`,
          animationDelay: `${balloon.delay}s`,
          animationDuration: `${balloon.duration}s`,
          background: balloon.background,
          boxShadow: balloon.shadow
        })
        }, [
          _createElementVNode("span", null, _toDisplayString(balloon.emoji), 1)
        ], 4))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_5, [
      _cache[6] || (_cache[6] = _createElementVNode("h1", { class: "headline" }, "Happy Birthday favorite cousin", -1)),
      _cache[7] || (_cache[7] = _createElementVNode("p", { class: "side-note" }, "PS: sorry I forgot the past 3 years :(", -1)),
      _createElementVNode("section", _hoisted_6, [
        _cache[3] || (_cache[3] = _createElementVNode("h2", null, "Truck", -1)),
        _cache[4] || (_cache[4] = _createElementVNode("p", { class: "truck-caption" }, "I know you love your massive truck so that is what I put here", -1)),
        _createElementVNode("div", _hoisted_7, [
          _cache[0] || (_cache[0] = _createElementVNode("div", { class: "truck-asphalt" }, null, -1)),
          _cache[1] || (_cache[1] = _createElementVNode("div", { class: "truck-center-line" }, null, -1)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(truckLights.value, (light) => {
            return (_openBlock(), _createElementBlock("div", {
              key: `light-${light.id}`,
              class: "truck-light",
              style: _normalizeStyle({
              left: `${light.left}%`,
              animationDelay: `${light.delay}s`,
              background: light.color
            })
            }, null, 4))
          }), 128)),
          _cache[2] || (_cache[2] = _createStaticVNode("<div class=\"truck-rig\" data-v-4a4e8cd4><div class=\"truck-cab\" data-v-4a4e8cd4><div class=\"truck-window\" data-v-4a4e8cd4></div><div class=\"truck-flag\" data-v-4a4e8cd4>16</div></div><div class=\"truck-bed\" data-v-4a4e8cd4><div class=\"truck-decal\" data-v-4a4e8cd4>KB</div></div><div class=\"truck-wheel front\" data-v-4a4e8cd4></div><div class=\"truck-wheel rear\" data-v-4a4e8cd4></div><div class=\"truck-headlight\" data-v-4a4e8cd4></div><div class=\"truck-tailglow\" data-v-4a4e8cd4></div></div>", 1))
        ])
      ]),
      _createElementVNode("section", _hoisted_8, [
        _cache[5] || (_cache[5] = _createElementVNode("h2", null, "Love Letters From Your Study Crew", -1)),
        _createElementVNode("div", _hoisted_9, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(appreciationNotes, (note) => {
            return _createElementVNode("article", {
              key: note.text,
              class: "gratitude-note",
              style: _normalizeStyle({ borderColor: note.accent })
            }, [
              _createElementVNode("span", {
                class: "note-accent",
                style: _normalizeStyle({ background: note.accent })
              }, null, 4),
              _createElementVNode("p", null, _toDisplayString(note.text), 1)
            ], 4)
          }), 64))
        ])
      ]),
      _createElementVNode("footer", { class: "closing" }, [
        _createElementVNode("button", {
          class: "close-secondary",
          onClick: closeSurprise
        }, "✨ Take Me To My Dashboard")
      ])
    ]),
    (showFireworks.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(fireworkBursts.value, (burst) => {
            return (_openBlock(), _createElementBlock("div", {
              key: `firework-${burst.id}`,
              class: "firework-burst",
              style: _normalizeStyle({
          left: `${burst.left}%`,
          top: `${burst.top}%`,
          animationDelay: `${burst.delay}s`,
          background: `radial-gradient(circle, hsla(${burst.hue}, 95%, 75%, 1) 0%, transparent 60%)`
        })
            }, null, 4))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})